module.exports = {
  siteMetadata: {
    title: 'JBVC | ',
  },
  plugins: [
    {
      resolve: 'gatsby-source-contentful',
      options: {
        spaceId: 'ojqtc3jptqun',
        accessToken:'63abf4221b7343863093fc8496820e53d0ae69d0abbab5f152540bc7589c2a2d'
      }
    },
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-remove-trailing-slashes',
    'gatsby-transformer-remark',
    //'gatsby-plugin-sharp',
    //'gatsby-transformer-sharp',
    {
      resolve: `gatsby-plugin-env-variables`,
      options: {
        allowList: ["REACT_APP_API_URL", 'NODE_ENV']
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `pages`,
        path: `${__dirname}/src/pages/`,
      },
    },
    `gatsby-plugin-lodash`,
    {
      resolve: 'gatsby-plugin-mailchimp',
      options: {
        endpoint: 'https://jbvc-foundation.us16.list-manage.com/subscribe/post?u=7bd55c846f54004e7845d1de4&amp;id=9e0d168c38',
      },
    },
    {
      resolve: `gatsby-plugin-favicon`,
      options: {
        logo: "./src/favicon.png",
        injectHTML: true,
        icons: {
          android: true,
          appleIcon: true,
          appleStartup: true,
          coast: true,
          favicons: true,
          firefox: true,
          twitter: true,
          yandex: true,
          windows: true
        }
      }
    },
    {
      resolve: `gatsby-plugin-google-analytics`,
      options: {
        trackingId: "UA-119687393-1",
        // Puts tracking script in the head instead of the body
        head: false,
        // Setting this parameter is optional
        anonymize: true,
        // Setting this parameter is also optional
        respectDNT: true,
        // Avoids sending pageview hits from custom paths
        exclude: ["/preview/**", "/do-not-track/me/too/"],
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./gatsby-config.js